export const showWholeCollapsibleContent = () => {
  const parentNode =
    document.querySelector<HTMLElement>('.o-MobileApp-Faq')?.parentNode

  if (parentNode) {
    const clickHandler = (event: Event) => {
      const showMoreButton = document.querySelector<HTMLElement>(
        '.o-Faq__ShowAll__Button'
      )
      const clickedElement = event.target

      if (
        clickedElement instanceof HTMLElement &&
        clickedElement.closest('.m-Collapsible')
      ) {
        showMoreButton?.click()

        parentNode.removeEventListener('click', clickHandler)
      }
    }
    parentNode.addEventListener('click', clickHandler)
  }
}
